import { t } from "@/i18n-js/instance";
import { LinkButton } from "@circle-react-uikit/LinkButton";
import { Typography } from "@circle-react-uikit/Typography";

interface AccountManagerProps {
  email: string;
  image: string;
  name: string;
}

export const AccountManager = ({ name, email, image }: AccountManagerProps) => (
  <div className="border-primary inline-block rounded-lg border">
    <img
      loading="lazy"
      alt={t("settings.billing.account_manager.alt", { name })}
      src={image}
      className="rounded-t-lg"
    />
    <div className="p-5">
      <div>
        <Typography.LabelMd weight="semibold">{name}</Typography.LabelMd>
      </div>
      <div>
        <Typography.LabelMd>
          {t("settings.billing.account_manager.contact")}
        </Typography.LabelMd>
      </div>
      <div className="pt-6">
        <LinkButton href={`mailto:${email}`} variant="circle">
          {t("settings.billing.account_manager.message")}
        </LinkButton>
      </div>
    </div>
  </div>
);
